export const DDNJ_INITIATE_PROPOSAL_FORM_ID = 'ddnj-initiate-proposal-form';
export const DDNJ_SIC_WARNING_ALERT_TEST_ID = 'ddnj-initiate-proposal-sic-warning-alert';
